<template>
	<Transition name="popup">
		<div v-if="modelValue" :class="['popup', {'active': modelValue}]">
			<div class="popup-overlay"></div>
			<div :class="['popup-content', customClass, modalClass]" ref="contentRef" :style="contentStyle">				
				<button v-if="!isLoginPopXButton && !isRequiredAuth" @click="handleClose" class="popup-close" aria-label="닫기"></button>
				<button v-if="!isLoginPopXButton && isRequiredAuth" @click="handleClose2" class="popup-close" aria-label="닫기"></button>

				<slot></slot>
			</div>
		</div>
	</Transition>
</template>

<script setup lang="ts">
import { watch, onMounted } from 'vue'
const props = defineProps({
	modelValue: {
		type: Boolean,
		required: true
	},
	modalClass: {
		type: String,
		required: false
	},
	customClass: {
		type: String,
		default: ''
	},
	showCloseButton: {
		type: Boolean,
		default: true
	},
	closeOnOverlay: {
		type: Boolean,
		default: true
	},
	contentStyle: {
		type: Object,
		default: () =>({})
	}
})

// 전역 팝업
const {
showAlert,
isLoginPopXButton
} = usePopup()

const emit = defineEmits(['update:modelValue', 'close', 'loginOpend', 'loginClosed'])

const contentRef = ref<HTMLElement | null>(null)

defineExpose({ contentRef })

const showCloseButtonRef = ref(props.showCloseButton);
  // 전역 팝업
  const {
    isRequiredAuth,
	incrementPopupCount,
	decrementPopupCount,
	showConfirm,
	addPopupStack,
	closeLoginPopup,
	removePopupStack
  } = usePopup()
  

// 팝업만의 고유 id
const instanceId = useId()
const handleClose = async () => {
	if (props.closeOnOverlay) {
		emit('update:modelValue', false)
		emit('close')
	}
}

const handleClose2 = async () => {
	const result = await showConfirm({
    title: '로그인 필요 안내',
    message: "로그인이 필요한 화면입니다.",
    confirmText: '홈으로가기',
    cancelText: '로그인하기'
  })

  if(result) {
	closeLoginPopup();
	navigateTo({path: '/'}, {external: false});
  }
}
watch(() => props.modelValue, async (newVal, oldVal) => {
	
	if (newVal) {
		document.body.style.overflow = "hidden" 

		incrementPopupCount()
		addPopupStack(instanceId) // 팝업 열리면 스택 추가

		await nextTick()
		emit('loginOpend')
	} else if (oldVal === true && !newVal) {
		document.body.style.overflow = ""
		decrementPopupCount()
		removePopupStack(instanceId) // 팝업 닫히면 스택 제거
		emit('loginClosed')
	}
})
</script>